import { render, staticRenderFns } from "./consumeList.vue?vue&type=template&id=d449b6c8&scoped=true"
import script from "./consumeList.vue?vue&type=script&lang=js"
export * from "./consumeList.vue?vue&type=script&lang=js"
import style0 from "./consumeList.vue?vue&type=style&index=0&id=d449b6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d449b6c8",
  null
  
)

export default component.exports